import React from "react";
import { docsComponents } from "@/lib/docs-theme";

interface DocCardProps {
  children: React.ReactNode;
  className?: string;
}

export default function DocCard({ children, className = "" }: DocCardProps) {
  return <div className={`${docsComponents.card} p-6 ${className}`}>{children}</div>;
}
